import "./index.css";
export default function Home() {
    return(
        <div id="wd-home" className="me-3 pt-2">
            <div className="d-fill align-items-strech mb-5 ">
            <img src="images/Alfonso_BC_Khoury.jpg"  className="wd-image-home ms-2"></img>
            </div>
            <div className="row mb-5">
                <div className="col-md-1 col-lg-2 mb-5">
                </div>
                <div className="col-md-10 col-lg-8 mb-5">
                    <p>
                    I help businesses minimize financial losses by detecting anomalies and forecasting trends in key performance indicators. Using the CRISP-DM methodology and advanced machine learning, I uncover hidden patterns and insights that drive data-informed decisions. Delivering actionable insights to improve operations and strategy.
                    </p>
                    <p>
                    I’m a Data Scientist with 4+ years of hands-on experience designing, deploying, and optimizing machine learning solutions — with a focus on anomaly detection, time series modeling, and probabilistic reasoning.
                    </p>
                </div>
                <div className="col-md-1 col-lg-2 mb-5">
                </div>
            </div>
        </div>
    );
}